import React, { forwardRef } from "react";
import { cn } from "@/lib/utils/cn";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ className, label, error, id, ...props }, ref) => {
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={id} className="block text-[13px] font-medium text-text-primary mb-1.5">
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={id}
        className={cn(
          "w-full rounded-button border px-4 py-2.5 text-[13px] transition-all duration-150 placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-offset-0",
          error
            ? "border-status-critical focus:border-status-critical focus:ring-red-500/20"
            : "border-border focus:border-primary-500 focus:ring-primary-500/20",
          className
        )}
        {...props}
      />
      {error && error.trim() && <p className="mt-1 text-[12px] text-status-critical">{error}</p>}
    </div>
  );
});

Input.displayName = "Input";
export default Input;
